export default [
  {
    id: 1,
    value: 'MONDAY',
    name: 'Segunda',
    shortName: 'Seg',
    checked: false,
    weekend: false,
  },
  {
    id: 2,
    value: 'TUESDAY',
    name: 'Terça',
    shortName: 'Ter',
    checked: false,
    weekend: false,
  },
  {
    id: 3,
    value: 'WEDNESDAY',
    name: 'Quarta',
    shortName: 'Qua',
    checked: false,
    weekend: false,
  },
  {
    id: 4,
    value: 'THURSDAY',
    name: 'Quinta',
    shortName: 'Qui',
    checked: false,
    weekend: false,
  },
  {
    id: 5,
    value: 'FRIDAY',
    name: 'Sexta',
    shortName: 'Sex',
    checked: false,
    weekend: false,
  },
  {
    id: 6,
    value: 'SATURDAY',
    name: 'Sábado',
    shortName: 'Sáb',
    checked: false,
    weekend: true,
  },
  {
    id: 0,
    value: 'SUNDAY',
    name: 'Domingo',
    shortName: 'Dom',
    checked: false,
    weekend: true,
  },
];
